import Swal from "sweetalert2";
import { quick_Action_Run_Generate_ChunksApi } from "../../Apis/user/ApiConfig";
import {
  QUICK_ACTION_RUN_GENERATE_CHUNKS_ERROR,
  QUICK_ACTION_RUN_GENERATE_CHUNKS_REQUEST,
  QUICK_ACTION_RUN_GENERATE_CHUNKS_SUCCESS,
} from "../../Types/user/Types";

export const quick_Action_Run_Generate_Chunks_Success = (res) => {
  return {
    type: QUICK_ACTION_RUN_GENERATE_CHUNKS_SUCCESS,
    payload: res,
  };
};
export const quick_Action_Run_Generate_Chunks_Error = (error) => {
  return {
    type: QUICK_ACTION_RUN_GENERATE_CHUNKS_ERROR,
    error: error,
  };
};

export const quick_Action_Run_Generate_Chunks_Request = (res) => {
  return {
    type: QUICK_ACTION_RUN_GENERATE_CHUNKS_REQUEST,
    payload: res,
  };
};

export const quick_Action_Run_Generate_ChunksHandler = (data, id) => {
  return (dispatch) => {
    dispatch(quick_Action_Run_Generate_Chunks_Request());
    try {
      quick_Action_Run_Generate_ChunksApi(data, id)
        .then((res) => {
          if (res) {
            if (res && res?.data && res?.status === 201) {
              dispatch(quick_Action_Run_Generate_Chunks_Success(res?.data));
            } else {
              let data = res?.response?.data;

              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                html: `
                    <p>${data ? data?.message : "Something went wrong!"}</p>
                `,
                confirmButtonColor: "rgb(231,52,70)",
              });
              dispatch(quick_Action_Run_Generate_Chunks_Error(res));
            }
          } else {
            dispatch(quick_Action_Run_Generate_Chunks_Error(""));
          }
        })
        .catch((err) => {
          dispatch(
            quick_Action_Run_Generate_Chunks_Error("Something Went Wrong!!!")
          );
        });
    } catch (err) {
      dispatch(quick_Action_Run_Generate_Chunks_Error(err));
    }
  };
};
